<template>
  <div class="handle">
    <v-icon class="drag__icon">drag_indicator</v-icon>
    <h4>Question de type QCM</h4>

    <p v-if="control.value === ''">Aucune question sélectionnée</p>
    <p v-else>{{ questionSelected !== undefined ? questionSelected.label : '' }}</p>
  </div>
</template>

<script>
import inputMixin from '@/components/questionnaires/fields/inputs/inputMixin'
import { mapGetters } from 'vuex'

export default {
  name: 'LikertQuestionInput',
  mixins: [inputMixin],
  data () {
    return {
      type: 'likert',
      editPanel: 'MCQQuestionEditPanel'
    }
  },
  computed: {
    ...mapGetters('Questions', [
      'questionsMCQ'
    ]),
    questionSelected () {
      return this.questionsMCQ.find(question => question.id === this.control.value)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "grab";

  .handle {
    p {
      margin-left: 20px;
    }
  }
</style>
